import type { FC, ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import useUser from 'hooks/useUser';
import useSession from 'hooks/useSession';

interface AuthGuardProps {
    children: ReactNode;
}

export const AuthGuard: FC<AuthGuardProps> = ({ children }) => {
    const { token } = useSession();
    const { user } = useUser();
    const router = useRouter();
    const [checked, setChecked] = useState(false);

    useEffect(
        () => {
            if (!router.isReady) {
                return;
            }

            if (!token) {
                router.push({
                    pathname: '/prijava',
                    query: { returnUrl: router.asPath }
                });
            } else {
                if (user && !user?.completed_registration_at) router.push('/zakljuci-registracijo');
                setChecked(true);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [router.isReady]
    );

    if (!checked) {
        return null;
    }

    // If got here, it means that the redirect did not occur, and that tells us that the user is
    // authenticated / authorized.

    return <>{children}</>;
};

AuthGuard.propTypes = {
    children: PropTypes.node
};
